exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".content-cell[data-v-bfcfc966]{display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;overflow:hidden;text-overflow:ellipsis;line-height:1.5;max-height:3em}[data-v-bfcfc966] .content-tooltip{max-width:4rem !important;white-space:pre-wrap;word-wrap:break-word;font-size:0.25333rem;padding:0.13333rem 0.16rem;border-radius:0.08rem;box-shadow:0 0.05333rem 0.16rem rgba(0,0,0,.15);background-color:#fff;border:0.01333rem solid #ebeef5;color:#606266;line-height:1.6}", ""]);

// exports
